import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';

import { getFlowConnectionAvailableActions, rootFlowConnectionSaga } from '~src/flow/sagas/FlowConnectionSagas';
import { rootResourceActionsSaga } from '~src/resourceActions/sagas/ResourceActionsSaga';
import { rootPrivateConnectionsSagas } from '~src/settings/privateconnect-settings/sagas/PrivateConnectSagas';
import { rootCredentialEncryptionSagas } from '~src/settings/security-settings/sections/credential-encryption/sagas/CredentialEncryptionSaga';
import { rootExtractEncryptionSagas } from '~src/settings/security-settings/sections/extract-encryption/sagas/ExtractEncryptionSaga';
import { rootSiteAdminResourcesSaga } from '~src/siteManagement/sagas/SiteAdminResourcesSaga';
import { rootAvailableActionsForEntitySaga } from '~src/spacesPlatform/sagas/AvailableActionsForEntitySagas';
import { rootSpacesSaga } from '~src/spacesPlatform/sagas/RootSpacesSaga';
import { rootServerUsersSpaceSaga } from '~src/userManagement/sagas/ServerUserSpaceSagas';

import { rootRequestFailedSaga } from '../../bootstrap/redux/sagas/RequestFailedSaga';
import { rootDraftsSaga } from '../../drafts/sagas/DraftsSagas';
import { rootPersonalSpaceSaga } from '../../personalSpace/sagas/PersonalSpaceSaga';
import { rootSiteSagas } from '../../siteManagement/sagas/SitesSagas';
import { rootDisplayModeSaga } from '../../spacesPlatform/sagas/DisplayModeSaga';
import { rootStartersSaga } from '../../starters/sagas/StartersSagas';
import { rootUploadContentSaga } from '../../uploadContent/sagas/UploadContentSaga';
import { rootUserNotificationSettingsSagas } from '../../userNotifications/redux/sagas/UserNotificationSettingsSaga';
import { rootUserNotificationSagas } from '../../userNotifications/redux/sagas/UserNotificationsSaga';

export function* rootSaga(): SagaIterator {
  yield all([
    fork(rootDisplayModeSaga),
    fork(rootSpacesSaga),
    fork(rootRequestFailedSaga),
    fork(rootAvailableActionsForEntitySaga, getFlowConnectionAvailableActions),
    fork(rootFlowConnectionSaga),
    fork(rootSiteSagas),
    fork(rootSiteAdminResourcesSaga),
    fork(rootResourceActionsSaga),
    fork(rootStartersSaga),
    fork(rootUploadContentSaga),
    fork(rootDraftsSaga),
    fork(rootUserNotificationSagas),
    fork(rootUserNotificationSettingsSagas),
    fork(rootPersonalSpaceSaga),
    fork(rootServerUsersSpaceSaga),
    fork(rootPrivateConnectionsSagas),
    fork(rootExtractEncryptionSagas),
    fork(rootCredentialEncryptionSagas)
  ]);
}
